module.exports = __webpack_public_path__ + "img/sam.0101cb4c.jpg";